import { render } from "./TeamsCardSmall.vue?vue&type=template&id=36f91fc2"
import script from "./TeamsCardSmall.vue?vue&type=script&lang=js"
export * from "./TeamsCardSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__